import React, { useState } from 'react';
import { Button } from './ui/button';
import { Calendar, MapPin, Server, Shield } from 'lucide-react';
import { Badge } from './ui/badge';
import { Link } from 'react-router-dom';
import BookConsultModal from './BookConsultModal';

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="pt-24 pb-16 bg-gradient-to-br from-slate-50 via-blue-50/50 to-cyan-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-gray-900 leading-[1.1] tracking-tight">
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-light">
                  Managed IT for
                </span>
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-semibold bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-700 bg-clip-text text-transparent mt-1">
                  Small Businesses
                </span>
                <span className="block text-4xl sm:text-5xl lg:text-[3.5rem] font-semibold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                  & Nonprofits
                </span>
                <span className="block text-xl sm:text-2xl font-medium text-cyan-600 mt-4 tracking-normal">(1–50 Users)</span>
              </h1>
              <p className="text-lg sm:text-xl text-gray-600 leading-relaxed max-w-lg">
                Fast support, secure Microsoft 365, and reliable networks—without the headaches.
              </p>
            </div>

            {/* Badges */}
            <div className="flex flex-wrap gap-3">
              <Badge variant="outline" className="px-4 py-2 text-sm bg-white/80 backdrop-blur-sm border-blue-200 shadow-sm">
                <MapPin className="w-4 h-4 mr-2 text-blue-600" />
                South Shore / Greater Boston
              </Badge>
              <Badge variant="outline" className="px-4 py-2 text-sm bg-white/80 backdrop-blur-sm border-blue-200 shadow-sm">
                <Server className="w-4 h-4 mr-2 text-blue-600" />
                Microsoft 365 + Network Specialists
              </Badge>
              <Badge variant="outline" className="px-4 py-2 text-sm bg-white/80 backdrop-blur-sm border-blue-200 shadow-sm">
                <Shield className="w-4 h-4 mr-2 text-blue-600" />
                Security-first support
              </Badge>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <Button 
                size="lg" 
                className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white px-8 shadow-lg shadow-blue-500/25 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/30"
                onClick={() => setShowModal(true)}
              >
                <Calendar className="w-5 h-5 mr-2" />
                Book a Free Consult
              </Button>
              <Link to="/pricing">
                <Button size="lg" variant="outline" className="border-gray-300 hover:bg-white/80 hover:border-blue-300 transition-all duration-300">
                  View Pricing
                </Button>
              </Link>
            </div>

            {/* Response Time */}
            <p className="text-sm text-gray-600 flex items-center">
              <span className="inline-block w-2 h-2 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full mr-2 animate-pulse"></span>
              We respond within 1 business day (often faster). Emergency support available.
            </p>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=800"
                alt="IT support team collaborating"
                className="w-full h-auto"
              />
              {/* Experience Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm rounded-xl shadow-xl p-4 flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-lg flex items-center justify-center">
                  <Server className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">25+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookConsultModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </section>
  );
};

export default HeroSection;